import { Component, Inject, NgZone } from '@angular/core';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { IdexService } from 'app/idex.service';
import { TranslateService } from '@ngx-translate/core';
import { Toast } from '../../shared/toast/toast';

@Component({
   selector: 'app-wait-for-import',
   templateUrl: 'wait-for-import.component.html',
   styleUrls: ['wait-for-import.component.css']
})
export class WaitForImportComponent {
    message = 'Waiting! create docs.';
    saveText = 'นำเข้า';
    id: any;
    name: any;
    items: any;
    access_token: any;
    path: any;
    status: string;
    progress = true;
    isBusiness: any;
    doc_id: any;
    constructor(private dialogRef: MatDialogRef<WaitForImportComponent>, @Inject(MAT_DIALOG_DATA) private data: any,
                private service: IdexService,
                private translate: TranslateService, private toast: Toast,private ngZone: NgZone,) {}

    google_saveFile(button: MatButton) {
        this.progress = true;
       this.translate.get('onedrive.importing').subscribe(s => {
          this.saveText = s;
       });
        button.disabled = true;
        if (this.isBusiness) {
            this.service.business_saveFile_googledrive(this.access_token, this.id, this.data.businessComponent.path,
               this.data.businessComponent.tin)
                .subscribe(() => {
                   this.dialogRef.close();
                    this.data.businessComponent.showDocument();
                    this.translate.get('alert.savefile').subscribe(s => {
                        this.toast.success(this.name + s);
                    });
                }, () => {
                    this.dialogRef.close();
                });
        } else {
            this.service.saveFile_googledrive(this.access_token, this.id, this.data.path, this.service.shareDocId)
                .subscribe(() => {
                   this.dialogRef.close();
                    this.data.filesComponent.showDocument();
                    this.translate.get('alert.savefile').subscribe(s => {
                        this.toast.success(this.name + s);
                    });
                }, () => {
                    this.dialogRef.close();
                });
        }
    }

    onedrive_saveFile(button: MatButton) {
        this.progress = true;
       this.translate.get('onedrive.importing').subscribe(s => {
          this.saveText = s;
       });
        button.disabled = true;
        if (this.isBusiness) {
            this.service.business_saveFile_onedrive(localStorage.getItem('access_token'), this.id, this.path, this.data.tin, this.name)
                .subscribe(
                    () => {
                        this.data.showDocument();
                        this.dialogRef.close();
                        this.translate.get('alert.savefile').subscribe(s => {
                            this.toast.success(this.name + s);
                        });
                }, () => {
                    this.dialogRef.close();
                });
        } else {
            this.service.saveFile_onedrive(localStorage.getItem('access_token'), this.id, this.path, this.name, this.service.shareDocId)
                .subscribe(
                    () => {
                        this.data.showDocument();
                        this.dialogRef.close();
                        this.translate.get('alert.savefile').subscribe(s => {
                            this.toast.success(this.name + s);
                        });
                    }, () => {
                        this.dialogRef.close();
                    });
        }
    }

    dropbox_saveFile(button: MatButton) {
        this.progress = true;
       this.translate.get('onedrive.importing').subscribe(s => {
          this.saveText = s;
       });
       this.service.saveFile_dropbox(this.access_token, this.id, this.path, this.name)
       .subscribe(
           () => {
               this.data.initDocument(this.path);
               this.dialogRef.close();
               this.translate.get('alert.savefile').subscribe(s => {
                   this.toast.success(this.name + s);
               });
           }, () => {
               this.dialogRef.close();
           });
    }

    edit_saveFile(button: MatButton) {
        this.progress = true;
       this.translate.get('onedrive.importing').subscribe(s => {
          this.saveText = s;
       });
        button.disabled = true;
        if (this.status === 'share') {
            this.service.share_saveOnedrive(this.doc_id, this.id, localStorage.getItem('access_token'))
                .subscribe(
                    () => {
                        this.dialogRef.close();
                        this.data.loaded = false;
                        this.data.initDocument();
                    }, () => {
                        this.dialogRef.close();
                    }
                );
        } else {
            this.service.edit_onedrive(this.doc_id, this.id, localStorage.getItem('access_token'))
                .subscribe(
                    () => {
                       this.dialogRef.close();
                        if (this.status === 'edit') {
                            this.data.showdocument.emit();
                        } else if (this.status === 'pdftron') {
                           window.location.reload();
                        } else {
                           this.data.loaded = false;
                           this.data.initDocument();
                        }
                        this.translate.get('alert.savefile').subscribe(s => {
                            this.toast.success(this.name + s);
                        });
                    }, () => {
                        this.dialogRef.close();
                    }
                );
        }
    }

   edit_googleDocs(button: MatButton) {
      this.progress = true;
      this.translate.get('onedrive.importing').subscribe(s => {
         this.saveText = s;
      });
      button.disabled = true;
      if (this.status === 'share-drive') {
         this.service.share_saveGoogledrive(this.doc_id, this.id, this.access_token)
            .subscribe(
               () => {
                  this.dialogRef.close();
                  this.data.loaded = false;
                  this.data.initDocument();
               }, () => {
                  this.dialogRef.close();
               }
            );
      } else {

         this.service.edit_googledrive(this.access_token, this.id, this.data.path, this.doc_id)
            .subscribe(
               () => {
                  this.dialogRef.close();
                  if (this.status === 'edit-drive') {
                     this.data.showdocument.emit();
                  } else if (this.status === 'pdftron-drive') {
                     window.location.reload();
                  } else {
                     this.data.loaded = false;
                     this.data.initDocument();
                  }
                  this.translate.get('alert.savefile').subscribe(s => {
                     this.toast.success(this.name + s);
                  });
               }, () => {
                  this.dialogRef.close();
               }
            );
      }

   }

    update(): void {
       // This is intentional.
    }

   close(): void {
      this.ngZone.run(() => {
         this.dialogRef.close();
      });
   }
}
